module.exports = __webpack_public_path__ + "img/STERiJECT_00_3.390ec004.png";